import Vue from 'vue'

import { login, logout } from "@/api/user"
import { setConsoleToken } from "@/utils/storage"


export const USER_LOGIN = 'USER_LOGIN'; // 登录成功
export const USER_LOGOUT = 'USER_LOGOUT'; // 退出登录

export default {
    
    /*state: {
        // state 存放状态
        name: '',
        status: '',
        consoleToken: null,
        roles: [],
    },*/
    state: JSON.parse(localStorage.getItem('user')) || {},

    getters: {
        // state 计算属性
        //state: JSON.parse(localStorage.getItem('user')) || {},
    },

    mutations: {
        // 更改 state 状态
        [USER_LOGIN] (state, user) {
            console.log("store user mutations USER_LOGIN, user:", user)
            localStorage.setItem('user', JSON.stringify(user))
            Object.assign(state, user)
            setConsoleToken('debug')
        },
        [USER_LOGOUT] (state) {
            console.log("store user mutations USER_LOGOUT")
            localStorage.removeItem('consoleToken')
            localStorage.removeItem('user')
            Object.keys(state).forEach(k => Vue.delete(state, k))
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles
        },
        SET_NAME: (state, name) => {
            state.name = name
        },
    },
    actions: {
        // 提交 mutation, 异步操作
        // {commit} ES2015 参数解构简化代码
        // 可以使用 ES2015 风格的计算属性命名功能来使用一个常量作为函数名
        [USER_LOGIN] ({commit}, user) {
            console.log("store user actions USER_LOGIN, user:", user)
            //return new Promise(function(resolve, reject) {
            //    console.info(user.username, user.password)
            //   login(user.username, user.password).then(resp => {
            //        console.log(resp.data)
                    commit('USER_LOGIN', user)
                    // setConsoleToken(token)
            /*        resolve(resp.data)
                }).catch(err => {
                    console.error(err)
                    reject(err)
                })
            })*/
        },
        [USER_LOGOUT] ({commit}) {
            console.log("store user actions USER_LOGOUT")
            //return new Promise(function(resolve, reject) {
                //logout().then(resp => {
                    //console.log(resp.data)
                    commit(USER_LOGOUT)
                    /*resolve(resp.data)
                }).catch(err => {
                    console.error(err)
                    reject(err)
                })
            })*/
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/store/modules/user.js
// module id = null
// module chunks = 